import { CalendarPayloadFields } from "@ihr-radioedit/inferno-core";

export type EventDate = {
    begin: number | null | undefined;
    enabled: boolean;
    end: number | null | undefined;
};

export const filterEventDates = (eventDates: EventDate[]) => {
    if (eventDates.length > 0) {
        const currentDate = new Date();
        return eventDates.filter(
            eventDate =>
                (eventDate.begin ?? 0) >= currentDate.getTime() || currentDate.getTime() < (eventDate.end ?? 0),
        );
    }

    return eventDates;
};

export const getEventStartDate = (fields: CalendarPayloadFields): number | null | undefined => {
    if (fields) {
        const { event_date } = fields;
        if (!!event_date?.value.length) {
            return event_date.value[0]?.begin;
        }
    }
    return null;
};

export const getEventEndDate = (fields: CalendarPayloadFields): number | null | undefined => {
    if (fields) {
        const { event_date } = fields;
        if (!!event_date?.value.length) {
            return event_date.value[0]?.end;
        }
    }
    return null;
};

export const getEventVenueName = ({ venue_name }: CalendarPayloadFields): string | null | undefined =>
    venue_name?.value ?? null;

export const getEventVenueAddress = ({ venue_address }: CalendarPayloadFields): string | null | undefined =>
    venue_address?.value ?? null;
